const state = {
  office: ""
}

export const customEditorRequiredFields = [
  { key: 'agent.office' },
]

export default state
